// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ga-0";
export var fulfillmentPanelBody = "_ga-1";